import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import AdminLayout from './pages/AdminPage';
import Dashboard from './pages/admin/Dashboard';
import Users from './pages/admin/Users'; 
import Reports from './pages/admin/Reports';
import MonthlyClosing from './pages/admin/MonthlyClosing';
import UserProfile from './pages/admin/UserProfile';
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="user" element={<Users />} /> 
          <Route path="reports" element={<Reports />} />
          <Route path="monthlyclosing" element={<MonthlyClosing />} />
          <Route path="userprofile" element={<UserProfile />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
